import Resources from "shared/actions/resourcesActions";

// eslint-disable-next-line import/prefer-default-export
export default class ProjectsRolesResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "project_role", "/api/v1/account/project_roles");
    this.refreshPageContentAfterCommit = true;
  }
}
